// extracted by mini-css-extract-plugin
export var alertIcon = "_sw-0";